import { CheckoutThemeFormValues } from './types';

export const defaultCheckoutTheme: CheckoutThemeFormValues = {
  publisherId: '',
  _id: '',
  logo: 'https://media.appcharge.com/defaults/default-store-logo.svg',
  receiptLogo: 'https://media.appcharge.com/defaults/default-store-logo.svg',
  receiptHeader: 'https://media.appcharge.com/defaults/default-store-logo.svg',
  primaryColor: '#7122ff',
  textColor: '#ffffff',
  backgroundImage: 'https://media.appcharge.com/defaults/background.png',
  mobileBgImage: '',
  buttonColor: '#7122ff',
  buttonTextColor: '#ffffff'
};
